<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Categorias de Assinantes</h1>
                                    <p class="modern-subtitle">Gerencie as categorias que identificam a função de cada assinante envolvido ao artefato.</p>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div class="table-container">
                        <div class="table-wrapper">
                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <button @click="novoTipoEnvolvido" class="modern-btn modern-btn-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Nova Categoria
                                </button>
                            </div> <!-- custom-table-header -->
                            <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <thead>
                                    <tr>
                                        <th scope="col" class="text-left bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100">
                                            Categoria de Assinante
                                        </th>
                                        <th scope="col" class="text-center bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100"
                                            style="white-space: nowrap; width: 1%; padding-right: 60px;">
                                            Ações
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, idx) in tiposEnvolvidos"
                                        :key="(item.tipoEnvolvido && item.tipoEnvolvido.idTipoEnvolvido) || item.idTipoEnvolvido || idx">
                                        <!-- Nome -->
                                        <td data-label="Tipo de Envolvido">
                                            {{ (item.tipoEnvolvido.nmTipoEnvolvido)}}
                                        </td>

                                        <!-- Ações (visual) -->
                                        <td data-label="Ações" class="text-center action-cell" style="white-space: nowrap; padding-right: 60px;">
                                            <div class="action-buttons">
                                                <button :disabled="isPadrao(item)"
                                                        :aria-disabled="isPadrao(item)"
                                                        :title="isPadrao(item) ? 'Tipo padrão não possui ações' : 'Ver Detalhes'"
                                                        @click="!isPadrao(item) && abrirDetalhes(item.tipoEnvolvido.idTipoEnvolvido)"
                                                        class="action-btn action-btn-view">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                    </svg>
                                                    <span class="action-text">Detalhes</span>
                                                </button>

                                                <button :disabled="isPadrao(item)"
                                                        :aria-disabled="isPadrao(item)"
                                                        :title="isPadrao(item) ? 'Tipos padrão não podem ser excluídos' : 'Excluir'"
                                                        @click="!isPadrao(item) && deletarTipo(item.tipoEnvolvido.idTipoEnvolvido)"
                                                        class="action-btn action-btn-delete">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <!-- Vazio -->
                                    <tr v-if="!tiposEnvolvidos || tiposEnvolvidos.length === 0">
                                        <td colspan="2" class="text-center py-4 opacity-70">Nenhum tipo de envolvido encontrado.</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                <div class="pagination-controls flex items-center">
                                    <span @click="previousPage"
                                          :class="['page-box', { 'disabled': currentPage === 0 }]">
                                        <span class="navigation-symbol">«</span>
                                    </span>
                                    <span v-for="page in pagesToShow"
                                          :key="page"
                                          @click="goToPage(page)"
                                          :class="['page-box',page === currentPage ? 'btn btn-primary-soft' : '']">
                                        {{ page + 1 }}
                                    </span>

                                    <span @click="nextPage"
                                          :class="['page-box', { 'disabled': !temProximaPagina }]">
                                        <span class="navigation-symbol">»</span>
                                    </span>
                                </div> <!-- pagination-controll -->
                                <span class="text-sm font-semibold text-gray-600">Registros encontrados: {{ qtdRegistros }}</span>
                            </div> <!-- custom-table-footer -->
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>
        <!-- MODAL NOVO PROCESSO -->
        <div class="modal fade" id="ModalInclusao" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content border-0 shadow">
                    <div class="modal-header">
                        <h5 class="modal-title">Novo Tipo de Envolvido</h5>
                        <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                                data-bs-dismiss="modal" aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>
                    </div>

            <div class="modal-body">
                <p class="text mb-4">
                    Complete os campos abaixo para cadastrar uma nova Categoria.
                </p>

                <!-- Campo Nome da Categoria -->
                <div class="mb-3">
                    <label class="form-label">Nome da Categoria</label>
                    <input type="text" class="form-control"
                           v-model="nmTipoEnvolvido"
                           :class="{ 'border-danger': camposInvalidos.nmTipoEnvolvido }"
                           placeholder="Digite o nome da categoria" maxlength="200" />
                </div>
            </div>

            <div class="modal-footer">
                        <button type="button" class="btn btn-primary w-100" @click="salvarTipo">
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div> <!-- tyn-root-->
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import axios from 'axios'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import Swal from 'sweetalert2'

    export default {
        name: 'TiposEnvolvidos',
        components: { Header, Modais },
        data: function () {
            return {
                qtdRegistros: 0,
                currentPage: 0,
                pageSize: 7,
                tiposEnvolvidos: [],
                camposInvalidos: {
                    nmTipoEnvolvido: false,
                },
                idTipoEnvolvidoSelecionado: null,
                nmTipoEnvolvido: '',
            }
        },
        watch: {

        },

        methods: {
            load() {
                this.getTiposEnvolvidos();

            },

            getTiposEnvolvidos() {
                let $this = this;
                axios.get(`${urlApi}/TipoEnvolvido/Get`, {
                    params: {
                        index: $this.currentPage,
                        take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.tiposEnvolvidos = result.rows.map(p => ({
                                ...p,
                            }));
                            $this.qtdRegistros = result.qtdRecords;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar processos!", "warning");
                    });
            },

            fecharModalInclusao() {
                const el = document.getElementById('ModalInclusao');
                if (!el) return;
                const bs = window.bootstrap;
                const modal = bs.Modal.getOrCreateInstance(el);
                modal.hide();
            },

            novoTipoEnvolvido() {
                this.resetModal();
                this.idTipoEnvolvidoSelecionado = 0;
                this.abrirModalInclusao();
            },

            abrirModalInclusao() {
                const el = document.getElementById('ModalInclusao');
                if (!el) return;
                const bs = window.bootstrap;
                const modal = bs.Modal.getOrCreateInstance(el);
                modal.show();
            },

            abrirDetalhes(id) {
                const toNum = v => (v !== undefined && v !== null && v !== '' ? Number(v) : null);
                const targetId = toNum(id);
                const getId = o => toNum(o?.tipoEnvolvido?.idTipoEnvolvido ?? o?.idTipoEnvolvido);
                const getNome = o => (o?.tipoEnvolvido?.nmTipoEnvolvido ?? o?.nmTipoEnvolvido ?? '');

                const item = (this.tiposEnvolvidos || []).find(o => getId(o) === targetId);

                this.idTipoEnvolvidoSelecionado = targetId ?? 0;
                this.nmTipoEnvolvido = item ? getNome(item) : '';

                this.abrirModalInclusao();
            },

            resetModal() {
                this.idTipoEnvolvidoSelecionado = null;
                this.nmTipoEnvolvido = '';
                this.camposInvalidos.nmTipoEnvolvido = false;
            },

            async salvarTipo() {
                const nome = (this.nmTipoEnvolvido || '').trim();
                this.camposInvalidos.nmTipoEnvolvido = !nome;
                if (!nome) {
                    avisoErro('Informe o nome do tipo de envolvido.');
                    return;
                }

                const id = Number(this.idTipoEnvolvidoSelecionado) || 0;
                const payload = {
                    DadosTipoEnvolvido: {
                        idTipoEnvolvido: id,
                        nmTipoEnvolvido: nome
                    }
                };

                const criando = id === 0;

                try {
                    const res = await axios.post(`${urlApi}/TipoEnvolvido/Post`, payload);
                    if (res.data?.success) {
                        avisoToast(
                            criando ? 'Tipo de Envolvido criado com sucesso!' : 'Tipo de Envolvido atualizado com sucesso!',
                            'success'
                        );
                        this.getTiposEnvolvidos();
                        this.fecharModalInclusao();
                    } else {
                        const erroMsg = res.data?.msg || 'Erro ao salvar tipo de envolvido!';
                        avisoErro(erroMsg);
                        avisoToast(erroMsg, 'warning');
                    }
                } catch (err) {
                    const msg = err?.response?.data?.msg || err.message || 'Erro desconhecido';
                    avisoErro(msg);
                }
            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.getTiposEnvolvidos();
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++;
                    this.getTiposEnvolvidos();
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex;
                    this.getTiposEnvolvidos();
                }
            },

            isPadrao(item) {
                const v = item?.tipoEnvolvido?.flPadrao ?? item?.flPadrao;
                //  0/1, "0"/"1"
                if (typeof v === 'boolean') return v;
                if (typeof v === 'number') return v === 1;
                return false;
            },

            deletarTipo(id) {
                Swal.fire({
                    title: 'Tem certeza?',
                    text: 'Essa ação não poderá ser desfeita!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, excluir!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/TipoEnvolvido/Delete`, {
                            idTipoEnvolvido: id
                        })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Função excluída com sucesso!", "success");
                                    this.getTiposEnvolvidos();
                                } else {
                                    const erroMsg = res.data.msg || "Erro ao excluir Função!";
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, "warning");
                                }
                            })
                            .catch(err => {
                                console.error("Erro ao excluir Função:", err);
                                avisoErro(err.message || "Erro desconhecido");
                                avisoToast("Erro ao excluir Função!", "warning");
                            });
                    }
                });
            },
        },

        mounted() {
            this.load();
            const el = document.getElementById('ModalInclusao');
            if (el) el.addEventListener('hidden.bs.modal', this.resetModal);
        },

        beforeDestroy() {
            const el = document.getElementById('ModalInclusao');
            if (el) el.removeEventListener('hidden.bs.modal', this.resetModal);
        },

        computed: {
            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize);
            },
            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages;
            },
            pagesToShow() {
                const maxPages = 5;
                const pages = [];

                let start = Math.max(this.currentPage - 2, 0);
                let end = Math.min(start + maxPages, this.totalPages);

                if (end - start < maxPages) {
                    start = Math.max(end - maxPages, 0);
                }

                for (let i = start; i < end; i++) {
                    pages.push(i);
                }

                return pages;
            },
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato === 'Sim';
            },
            hasMatchingWorkflow() {
                const idLeg = Number(this.legislacaoSelecionadaId);
                const idTipo = Number(this.ProcessoSelecionadoId);
                if (!idLeg || !idTipo) return false;

                return (this.processosWorkflow || []).some(w => {
                    const wf = w.processoWorkflow || w;
                    return Number(wf.idLegislacao) === idLeg && Number(wf.idTipoProcesso) === idTipo;
                });
            },

        }

    };
</script>

<style lang="css" scoped>
    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section {
        flex: 1;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 24px 0;
        }

        .header-content {
            flex-direction: column;
            text-align: center;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }
    }

    /* Container e Wrapper da Tabela */
    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 22px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 710px
    }

    /* Tabela Customizada */
    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
        border-collapse: collapse;
        background: white;
    }

        .custom-table th,
        .custom-table td {
            padding: 16px 20px;
            text-align: left;
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s ease;
        }

        .custom-table td {
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 15px;
            color: #374151;
        }

        .custom-table th {
            font-weight: 700;
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

    [data-bs-theme="dark"] .custom-table {
        background: #1f2937;
    }

        [data-bs-theme="dark"] .custom-table td {
            color: #e5e7eb;
        }

    .custom-table tbody tr {
        transition: all 0.2s ease;
    }

        .custom-table tbody tr:hover {
            background-color: #f9fafb;
            transform: scale(1.002);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: #374151;
        color: white;
    }

    /* Header da Tabela */
    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    /* Footer da Tabela */
    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        font-family: 'Segoe UI';
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    /* Botões de Ação */
    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

        .action-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .action-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

    .action-btn-delete {
        background: transparent;
        color: #ef4444;
        border-color: #ef4444;
    }

        .action-btn-delete::before {
            background: rgba(239, 68, 68, 0.1);
        }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
            border-color: #ef4444;
        }

    .action-btn:active {
        transform: translateY(0);
    }
    .action-btn[disabled] {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
    }
    @media (max-width: 768px) {
        .action-text {
            display: none;
        }

        .action-btn {
            padding: 8px;
        }
    }

    /* Paginação */
    .pagination-controls {
        display: flex;
        gap: 6px;
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        line-height: 1;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        background: white;
    }

        .page-box:hover {
            background-color: #f3f4f6;
            border-color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
        }

        .page-box.disabled {
            opacity: 0.4;
            pointer-events: none;
            cursor: default;
        }

        .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
            border-color: #2563eb;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    [data-bs-theme="dark"] .page-box {
        background-color: #1e293b;
        border: 2px solid #334155;
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .page-box:hover {
            background-color: #334155;
            border-color: #3b82f6;
        }

        [data-bs-theme="dark"] .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid #3b82f6;
        }

    .navigation-symbol {
        display: inline-block;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
        position: relative;
        overflow: hidden;
    }

        .modern-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .modern-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
        }

        .modern-btn:active {
            transform: translateY(0);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .modern-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

    /* Responsividade para Mobile */
    @media (max-width: 768px) {
        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

            .custom-table thead {
                display: none;
            }

            .custom-table tr {
                margin-bottom: 16px;
                border-radius: 8px;
                box-shadow: 0 1px 3px rgba(89, 89, 89, 0.5);
                overflow: hidden;
            }

            .custom-table td {
                text-align: left !important;
                padding: 12px 16px;
                position: relative;
                border: none;
                border-bottom: 1px solid #eee;
            }

                .custom-table td::before {
                    content: attr(data-label);
                    font-weight: 600;
                    display: block;
                    margin-bottom: 4px;
                    color: #6b7280;
                    font-size: 13px;
                }

                .custom-table td:last-child {
                    border-bottom: none;
                }
    }
</style>

